module.exports = __webpack_public_path__ + "media/images/footer-ec274a92.jpg";